import React from 'react'
import CardsCollectionSlider from './CardsCollectionSlider';
import CardsCollectionControls from './CardsCollectionControls';
import { SliderProvider } from 'components/SliderContext';

const CardsCollection = ({ collection }) => {

  const { name, series } = collection;

  return (
    <SliderProvider>
      <section className="cards-list cards-list--buy-packs" data-name={collection.name}>
        <header className="cards-list__header">
          <div className="cards-list__header-info">
            <h3 className="cards-list__title">{collection.name}</h3>
            <p className="cards-list__descr">{collection.description}</p>
          </div>
          <CardsCollectionControls />
        </header>
        {
          series && <CardsCollectionSlider list={series} collectionName={name} />
        }
      </section >
    </SliderProvider>
  )
}

export default CardsCollection;
